export default "__VITE_ASSET__BG8O_tkH__"